import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Message from './plugins/toast/index'
import router from './router'
import store from './store'
import BackAlert from "@/components/alert/BackAlert.vue";
import eruda from 'eruda'
import beforeInit from './utils/before.js'
import "./assets/scss/style.scss";
import './mixins'
Vue.config.productionTip = false
Vue.prototype.$message = Message
Vue.component('BackAlert', BackAlert)

//引入一些公用方法
import utils from '@/utils/utils.js';
Vue.prototype._utils = utils;

//开发环境或者测试环境
if (process.env.NODE_ENV === 'development' || location.host.indexOf('test') > -1) {
    const ua = navigator.userAgent
    // 是安卓、iphone 或者 ipad，才显示
    if (ua.match(/Android/i) !== null || ua.match(/iPad|iPod|iPhone/i) !== null) {
        eruda.init()
    }
}
(async() => {
    await beforeInit();
    new Vue({
        router,
        vuetify,
        store,
        render: h => h(App)
    }).$mount('#app')
})();

